import React from "react";
import { PropTypes } from "prop-types";
import { mergeOrOverrideCss } from "mrb/common/utils";

function NakiNigunPremiumBadgeTemplate({ classNameOverride, iconSize }) {
    const className = mergeOrOverrideCss(
        "u-icon u-icon--plan--sml u-icon--plan u-icon--plan--nigun",
        classNameOverride,
        iconSize ? `u-icon--plan--${iconSize}` : "u-icon--plan--base"
    );
    return <i className={className} />;
}

NakiNigunPremiumBadgeTemplate.propTypes = {
    classNameExtend: PropTypes.string,
    classNameOverride: PropTypes.string,
};

export default NakiNigunPremiumBadgeTemplate;
